module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA+klEQVR4Ae3UAaYCURSH8Q8YMZD3AJoHtYMA7y2g1QS1ghdpAUlBIIACKKGW0FCAICiEjFJQpxAic2eaM1Du71vAnzH3gGXFZ+WoMmV3a0qVHKlyGXBBHrowwCUlDj7yHD4OqeggIXXQI885dOBMHrU6YqiO2sw44KN2NA4cUAuMA8EbfKKGcaCB2o/xN/XQo61/aGYOM/Op0HPpPx27Pi6p8qjcz/WECh7WR8lQokaXEXP2BCwY0eWfEhmUCpQZckJCOjGkTIFEioyRmI0p8pIsPeTFemSJ6ZctkqAtf8TwxQZJ2JpvIjURRS0iLVUDKyKJrgQDdsCyrCvFDgaZKmjtoQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_person_black_24dp.png
// module id = 66
// module chunks = 0